export const DUMMY_EXPENSES = [
  {
    id: "e1",
    title: "Headphone",
    amount: 940,
    date: new Date(2023, 7, 14),
  },
  {
    id: "e2",
    title: "New Android",
    amount: 8000,
    date: new Date(2023, 2, 12),
  },
  {
    id: "e3",
    title: "Insurance",
    amount: 294,
    date: new Date(2021, 2, 28),
  },
  {
    id: "e4",
    title: "New Desk",
    amount: 4500,
    date: new Date(2023, 1, 12),
  },
  {
    id: "e5",
    title: "Utility bills",
    amount: 2000,
    date: new Date(2023, 8, 26),
  },
  {
    id: "e6",
    title: "Grocery expenses",
    amount: 3900,
    date: new Date(2023, 7, 21),
  },
  {
    id: "e7",
    title: "Transportation",
    amount: 9100,
    date: new Date(2023, 5, 22),
  },
  {
    id: "e8",
    title: "Entertainment expenses",
    amount: 4900,
    date: new Date(2023, 10, 10),
  },
  {
    id: "e9",
    title: "Library",
    amount: 6300,
    date: new Date(2023, 12, 12),
  },
  {
    id: "e10",
    title: "Wheel Alignment",
    amount: 5000,
    date: new Date(2023, 11, 1),
  },
  {
    id: "e11",
    title: "Cricket Kit",
    amount: 6000,
    date: new Date(2023, 0, 1),
  },
  {
    id: "e12",
    title: "Demo",
    amount: 5000,
    date: new Date(2023, 4, 1),
  },
];
